import { getField, updateField } from 'vuex-map-fields'
import { getNewId } from '@/utils/id'
import BaseStore from '@/store/baseStore'

export const namespaced = true

const baseUrl = '/su_table_points/'

const baseStore = new BaseStore(baseUrl)

const getDefaultState = () => ({
  ...structuredClone(baseStore.state)
})
export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  updateField
}
export const actions = {
  ...baseStore.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  },
  async add(context, suTableId) {
    let id = getNewId(context.state.items, 'id')
    let item = context.getters.getEmptyItem(id)
    item.su_table = suTableId
    context.commit('ADD_ITEM', item)
    context.commit('ADD_COUNT', 1)
  }
}

export const getters = {
  getField,
  getEmptyItem: (state) => (id) => {
    let emptyObj = {}
    Object.keys(state.options).forEach((key) => {
      if (state.options[key].type === 'choice') {
        emptyObj[key] = state.options[key]['choices'][0].value
      } else if (state.options[key].type === 'boolean') {
        emptyObj[key] = false
      } else if (state.options[key].type === 'string') {
        emptyObj[key] = ''
      } else {
        emptyObj[key] = null
      }
    })
    emptyObj.id = id
    return emptyObj
  }
}
